/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ControlListResponse,
  ControlResponse,
} from '../models/index';
import {
    ControlListResponseFromJSON,
    ControlListResponseToJSON,
    ControlResponseFromJSON,
    ControlResponseToJSON,
} from '../models/index';

export interface GetAllControlsRequest {
    page?: string;
    pageSize?: string;
}

export interface GetControlRequest {
    id: string;
}

/**
 * ControlApi - interface
 * 
 * @export
 * @interface ControlApiInterface
 */
export interface ControlApiInterface {
    /**
     * 
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApiInterface
     */
    getAllControlsRaw(requestParameters: GetAllControlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>>;

    /**
     */
    getAllControls(requestParameters: GetAllControlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApiInterface
     */
    getControlRaw(requestParameters: GetControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlResponse>>;

    /**
     */
    getControl(requestParameters: GetControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlResponse>;

}

/**
 * 
 */
export class ControlApi extends runtime.BaseAPI implements ControlApiInterface {

    /**
     */
    async getAllControlsRaw(requestParameters: GetAllControlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/control`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAllControls(requestParameters: GetAllControlsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse> {
        const response = await this.getAllControlsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getControlRaw(requestParameters: GetControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getControl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/control/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlResponseFromJSON(jsonValue));
    }

    /**
     */
    async getControl(requestParameters: GetControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlResponse> {
        const response = await this.getControlRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
